<script>
import { uuid } from "vue-uuid";
import { supabase } from "../supabase";
export default {
  props: {
    id: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      card: null,

      types: [
        {
          name: "learn",
          label: "Learn",
        },
        {
          name: "habit",
          label: "Habit",
        },
        {
          name: "check",
          label: "Check",
        },
        {
          name: "todo",
          label: "Todo",
        },
        {
          name: "readingList",
          label: "Book",
        },
        {
          name: "articleList",
          label: "Article",
        },
        {
          name: "standard",
          label: "Other",
        },
      ],
    };
  },
  created() {
    this.getCard();
  },
  methods: {
    getCard: async function () {
      // if id was passed in, get the card from the database
      // otherwise, create a new card
      if (this.id) {
        const { data, error } = await supabase
          .from("cards")
          .select("*")
          .eq("id", this.id);
        if (error) {
          console.log("error", error);
        } else {
          this.card = data[0];
        }
      } else {
        this.card = {
          id: uuid.v4(),
          type: "standard",
          front: "",
          back: "",
          nextShown: new Date() / 1000,
          ease: 0,
          interval: 1,
          repetition: 0,
          unit: "days",
          pack_id: null,
          // TODO: think about where to get pack_id or if we kill packs first
          occurrences: 0,
        };
      }
    },
    convertUnixTimestampToReadableDatetime(timestamp) {
      if (timestamp > 1) {
        return "next due at: " + new Date(timestamp * 1000).toLocaleString();
      } else {
        return "fresh card - due now";
      }
    },
  },
};
</script>

<template>
     <div class="card"  v-if="card">
          <div id="card-heading-wrapper">
            <h2
              class="card-heading"
              v-if="card.type === 'learn'"
              id="label-front"
            >
              Front
            </h2>
            <h2 class="card-heading" v-else>Content</h2>
            <div id="preview-button-wrapper">
              <button class="button small-button" @click="activatePreview">
                Preview
              </button>

              <div class="overlay-card card queue-card" v-if="preview">
                <div id="front">
                  <Markdown
                    v-if="card.type === 'readingList'"
                    :source="'## Read for a minute: \n' + front"
                  />
                  <Markdown
                    v-else
                    :source="front"
                    :class="{
                      'normal-text': card.front.length > 100,
                      'align-left': card.front.length > 100,
                    }"
                  />
                </div>
                <div id="queue-spacer" v-if="card.type == 'learn'"></div>
                <Markdown
                  v-if="card.type == 'learn'"
                  :source="back"
                  :class="{
                    'normal-text': card.back.length > 100,
                    'align-left': card.back.length > 100,
                  }"
                  id="back"
                />
              </div>
              <div class="overlay" v-if="preview"></div>
              <svg
                @click="deactivatePreview"
                v-if="preview"
                id="deactivatePreview"
                xmlns="http://www.w3.org/2000/svg"
                class="icon"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>

            <div id="preview-button-wrapper">
              <button class="button small-button" @click="toggleConnectDialog">
                Connect
              </button>

              <div class="overlay-card card queue-card" v-if="connectDialog">
                <div>
                  <h2>Connect a card</h2>
                  <h3>Search all decks</h3>
                </div>

                <input
                  class="input w-full"
                  type="text"
                  placeholder="Enter a term..."
                  v-model="globalSearchTerm"
                  @input="globalSearch"
                />
                <div class="flex-list">
                  <button
                    v-for="listCard in globalSearchResults"
                    :key="listCard._id"
                    class="card-list-card search-result"
                    @click="connectCard(listCard)"
                  >
                    <span v-if="listCard._front">
                      {{ listCard._front.substring(0, 100) }}
                    </span>
                    <span v-else> Unnamed Card </span>
                    <span v-if="listCard._front.length > 100">...</span>
                  </button>
                </div>
              </div>
              <div class="overlay" v-if="connectDialog"></div>
              <svg
                @click="toggleConnectDialog"
                v-if="connectDialog"
                id="deactivatePreview"
                xmlns="http://www.w3.org/2000/svg"
                class="icon"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>

            <span class="sep">|</span>
            <div id="save-wrapper">
              <span
                id="save-text"
                class="normal-text"
                :class="{ alert: savingState == 'not saved' }"
                >card {{ savingState }}</span
              >

              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon"
                :class="{ 'icon-grey': savingState !== 'not saved' }"
                @click="saveCard()"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"
                />
              </svg>
            </div>

            <span class="sep">|</span>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              @click="deleteCard"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              />
            </svg>
          </div>

          <textarea
            class="card-content"
            name="front"
            id="card-front"
            v-model="card.front"
            @input="savingState = 'not saved'"
            @change="saveCard"
          ></textarea>
          <div>
            <h2
              class="card-heading"
              v-if="card.type === 'learn'"
              id="label-back"
            >
              Back
            </h2>
          </div>
          <textarea
            name="back"
            class="card-content"
            id=""
            v-model="card.back"
            v-if="card.type === 'learn'"
            @input="savingState = 'not saved'"
            @change="saveCard"
          ></textarea>
          <select name="card-select" id="card-select" v-model="card.type">
            <option :value="type.name" v-for="type in types" :key="type.name">
              {{ type.name }}
            </option>
          </select>
          <div id="card-buttons" class="button-list">
            <button
              class="card-button button"
              :class="{ 'button-primary': card.type === type.name }"
              @click="setCardType(type.name)"
              v-for="type in types"
              :key="type.name"
            >
              {{ type.label }}
            </button>
          </div>
          <div id="type-info">
            <span v-if="this.card.type == 'learn'">
              'Learn' cards are classic flash cards. <br />
              They contain a front site with a question and a back site with an
              answer.
            </span>
            <span v-if="this.card.type == 'habit'">
              Use the 'Habit' card type get prompted to do habits. You decide
              how often you want to do a habit.
            </span>
            <span v-if="this.card.type == 'check'">
              'Check' cards are similar to 'Habit' cards, but refer to the past,
              like in "Did you sleep enough last night?"
            </span>
            <span v-if="this.card.type == 'todo'">
              'Todo' cards are for one-time actions you have to do - they
              disappear after you complete them.
            </span>
            <span v-if="this.card.type == 'readingList'">
              'Book' cards are for books you want to read.
              <br />
              Five items of your reading list stay in rotation at a time and
              after you finish a book another one from the list is picked.
            </span>
            <span v-if="this.card.type == 'articleList'">
              'Articles' cards are for articles, posts, papers and shorter
              pieces of text that you want to read.
              <br />
              Unlike books, you will be prompted to read articles in one go
              instead of page by page.
            </span>

            <span v-if="this.card.type == 'standard'">
              'Other' cards are for cards that are not of any of the other
              types. <br />
              They are occasionaly shown and could be used for cool quotes or
              paintings that you like.
            </span>
          </div>

          <p
            v-if="this.card.type == 'habit' || this.card.type == 'check'"
            id="interval-selector"
            class="extra-selector"
          >
            Show every
            <input
              class="input"
              type="number"
              v-model="card.interval"
              id="interval"
              default="1"
              @change="saveCard"
            />

            <span @click="switchUnit" class="switchableText">
              {{ card.unit }} </span
            >.
          </p>
          <p
            v-if="this.card.type == 'readingList'"
            id="started-reading-wrapper"
            class="extra-selector"
          >
            <input
              class="input"
              type="checkbox"
              :checked="card.startedReading"
              @change="setReadingStarted($event)"
              name="started-reading"
              id="started-reading"
            />
            <label for="started-reading">Started Reading</label>
          </p>
          <details id="card-details">
            <summary>Show Card Details</summary>
            occurrences: {{ card.occurrences }} <br />
            {{ convertUnixTimestampToReadableDatetime(card.nextShown) }} <br />
            <span v-if="card.type == 'learn'">
              Interval: {{ card.interval }}, Ease: {{ card.ease }}, Repetitions:
              {{ card.repetition }}
            </span>
          </details>
          <div id="card-checkbox">
            <input
              class="input"
              type="checkbox"
              v-model="card.priority"
              name="priority"
              id="priority"
              @change="saveCard"
            />
            <label for="priority">Priority Card</label>
          </div>
        </div>
</template>